import { graphQlClient } from '@config/graphqlClient';
import PunchClockGraphQL from '@graphql/punchClock.queries';
import { PunchClock, PunchClockAction } from '@models/punchClock.model';

interface GetPunchClocksByUserResponse {
  getPunchClocksByUser: PunchClock[];
}

export const punchClockService = {
  async getPunchClocksByUser(
    userId: string,
    action?: PunchClockAction | null,
  ): Promise<PunchClock[]> {
    const data: GetPunchClocksByUserResponse = await graphQlClient.request(
      PunchClockGraphQL.queries.getPunchClocksByUser,
      { userId, action: action ?? null },
    );
    return data.getPunchClocksByUser || [];
  },
};

export default punchClockService;
